import styled from 'styled-components';

const commonStyle = `
  align-self: center;
  margin: auto 10px;
`;

export const NavMenu = styled.div`
  display: flex;
  width: 100%;
  min-height: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

export const Dropdown = styled.div`
  display: flex;
  align-items: center;
  ${commonStyle};
`;

export const Logo = styled.img`
  display: block;
  width: ${({ $public }) => ($public ? '166px' : '150px')};
  height: auto;
  max-height: ${({ $public }) => ($public ? '52px' : '48px')};
  object-fit: contain;
  margin: 0;

  @media (max-width: 780px) {
    width: ${({ $public }) => ($public ? '154px' : '150px')} !important;
    height: auto;
    max-height: 48px;
  }

  @media (max-width: 480px) {
    width: 135px !important;
  }

  @media (max-width: 375px) {
    width: 120px !important;
  }
`;

export const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #e2e8f0;
  box-sizing: border-box;
  height: 68px;
  justify-content: space-between;
  padding: 0 5%;
  position: relative;
`;

export const Avatar = styled.span`
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  border-radius: 50%;
  display: inline-block;
  background: #ced4da no-repeat center/cover;
  position: relative;
  text-align: center;
  color: #868e96;
  font-weight: 600;
  vertical-align: bottom;
  font-size: 0.875rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  ${commonStyle}
`;

export const UserName = styled.span`
  display: block;
  text-transform: capitalize;
  color: var(--admincat-color-grey-17);
  align-self: center;
  line-height: 2;
  user-select: none;
`;

export const UserRole = styled.small`
  display: block;
  color: #9aa0ac;
  align-self: center;
`;

export const AvatarSection = styled.div`
  display: ${({ isAuth }) => (isAuth ? 'flex' : 'none')};
  align-items: center;
  cursor: pointer;
`;

export const Navbar = styled.ul`
  display: flex;
  list-style: none;
  align-items: center;
  gap: 12px;
  margin: 0;
  padding: 0;

  a {
    border: solid 1px #d7e3f7;
    padding: 10px 18px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    min-width: 90px;
    height: 42px;
    line-height: 1;
    color: #445273;
    background: #fff;
    transition: all 0.25s ease;

    .blue {
      color: #fff;
    }
  }

  a:hover {
    border-color: #aac2ed;
    box-shadow: 0 6px 16px rgba(76, 129, 190, 0.18);
    transform: translateY(-1px);
  }

  @media (max-width: 800px) {
    flex-direction: column;
    width: 100%;
    align-items: stretch;

    a {
      width: 100%;
      border-radius: 14px;
      padding: 18px 26px;
      font-size: 16px;
      border: 1px solid rgba(76, 129, 190, 0.18);
      background: linear-gradient(180deg, #f9fbff 0%, #edf2ff 100%);
      box-shadow: 0 12px 28px rgba(76, 129, 190, 0.14);
      color: #24385d;
    }

    a + a {
      margin-top: 12px;
    }

    a:hover {
      background: linear-gradient(180deg, #f2f6ff 0%, #e4ecff 100%);
      transform: translateX(4px);
      box-shadow: 0 14px 30px rgba(76, 129, 190, 0.2);
    }
  }
`;

const NavbarItem = styled.li`
  margin: 0;
  padding: 0;
  width: auto;

  > * {
    display: inline-block;
    transition: all 0.3s ease-in-out;
    white-space: nowrap;
  }

  > a.active {
    color: #1f2e4d;
    background: #eaf1ff;
  }

  > a.blue-link {
    color: #fff;
    background: rgb(68, 125, 189);
    border: none;
    box-shadow: 0 8px 18px rgba(68, 125, 189, 0.35);
    transition: background 0.25s ease;
  }

  @media (max-width: 800px) {
    margin-top: 12px;
    padding: 0;

    > * {
      width: 100%;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
    }

    > a:hover {
      transform: translateX(4px);
    }

    > a.blue-link {
      background: linear-gradient(135deg, #4c81be 0%, #3869a9 100%);
      color: #fff;
    }

    > a.blue-link:hover {
      background: linear-gradient(135deg, #3a6ba5 0%, #2d5a8f 100%);
    }
  }
`;

Navbar.Item = NavbarItem;
